import Keycloak from "keycloak-js";

const KC_URL = (window as any).__KEYCLOAK_URL__ || "http://localhost:8180";
const KC_REALM = (window as any).__KEYCLOAK_REALM__ || "mediskill";
const KC_CLIENT = (window as any).__KEYCLOAK_CLIENT__ || "mediskill-app";

let kc: Keycloak;

export function getKeycloak(): Keycloak { return kc; }
export function getToken(): string | undefined { return kc?.token; }
export function getUsername(): string | undefined { return (kc?.tokenParsed as any)?.preferred_username || kc?.subject; }
export function getRoles(): string[] { return (kc?.tokenParsed as any)?.realm_access?.roles ?? []; }
export function hasRole(role: string): boolean { return getRoles().includes(role); }

export async function initKeycloak(): Promise<boolean> {
  kc = new Keycloak({ url: KC_URL, realm: KC_REALM, clientId: KC_CLIENT });
  const auth = await kc.init({ onLoad: "check-sso", checkLoginIframe: false });

  if (auth) {
    // Token alle 30s erneuern
    setInterval(() => { kc.updateToken(60).catch(() => kc.login()); }, 30000);
    kc.onTokenExpired = () => { kc.updateToken(60); };
  }
  return auth;
}

export function login() { kc?.login(); }
export function logout() { kc?.logout({ redirectUri: window.location.origin }); }